export interface ActivityI {
  id: number;
  activity: string;
  mets: string; // decimal
  createdAt: string;
  updatedAt: string;
}
